import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Dropdown, Modal } from 'react-bootstrap'
import Select from 'react-select'
import { store } from 'store/index'

import { SHOW_LOADER, HIDE_LOADER } from 'store/loader/actions'
import DeleteModal from 'pages/parts/DeleteModal'
import { httpOk, GET, POST, PUT, DELETE } from 'helpers/api'

const AUTO_ADD_TYPE = {
	WHOLE_ORDER: 'whole_order',
	FOR_DISHES: 'for_dishes',
}

function resolveAutoAddTypeValue(typeOrId, types = []) {
	if (typeOrId && typeof typeOrId === 'object' && typeOrId.value) {
		return String(typeOrId.value)
	}
	const id = typeof typeOrId === 'object' ? typeOrId?.id : typeOrId
	const found = types.find((item) => Number(item.id) === Number(id))
	return found?.value ? String(found.value) : null
}

function Index() {
	const { t } = useTranslation()

	const [data, setData] = useState([])
	const [products, setProducts] = useState([])
	const [orderTypes, setOrderTypes] = useState([])
	const [autoAddRuleTypes, setAutoAddRuleTypes] = useState([])
	const [selectedItem, setSelectedItem] = useState({ quantity: 1, products: [], order_types: [] })
	const [showModal, setShowModal] = useState(false)
	const [modalDelete, setModalDelete] = useState(false)
	const [deleteModalParams, setDeleteModalParams] = useState({ id: 0, index: 0 })

	function isForDishesType(item = selectedItem) {
		return resolveAutoAddTypeValue(item.auto_add_rule_type_id, autoAddRuleTypes) === AUTO_ADD_TYPE.FOR_DISHES
			|| resolveAutoAddTypeValue({ value: item.auto_add_rule_type_value }, autoAddRuleTypes) === AUTO_ADD_TYPE.FOR_DISHES
	}

	async function createUpdate(e) {
		e.preventDefault()

		const payload = {
			...selectedItem,
			products: isForDishesType(selectedItem)
				? (selectedItem.products || []).map((item) => ({
					id: item.id ?? item.product_id,
					product_id: item.product_id ?? item.id,
					name: item.name,
				}))
				: [],
		}

		if (isForDishesType(payload) && !payload.products.length) {
			return
		}

		var response;
		if (payload.id) {
			response = await PUT('/auto-add-rules', payload, { loader: true })
		} else {
			response = await POST('/auto-add-rules', payload, { loader: true })
		}

		if (httpOk(response)) {
			getData()
			toggleModal(false)
		}
	}

	function toggleModal(bool = false, item = { quantity: 1, products: [], order_types: [] }) {
		setSelectedItem({
			...item,
			products: Array.isArray(item.products) ? item.products : [],
			order_types: Array.isArray(item.order_types) ? item.order_types : [],
		})
		setShowModal(bool)
	}

	async function deleteItem() {
		const response = await DELETE('/auto-add-rules', { 'id': deleteModalParams.id }, { loader: true })
		if (httpOk(response)) {
			getData()
			setModalDelete(false)
		}
	}

	async function getData() {
		store.dispatch(SHOW_LOADER());

		var response = await GET('/auto-add-rules', {}, {})
		if (httpOk(response)) setData(response.data)

		store.dispatch(HIDE_LOADER());
	}

	async function getDataAll() {
		store.dispatch(SHOW_LOADER());

		var response
		response = await GET('/auto-add-rules', {}, {})
		if (httpOk(response)) setData(response.data)

		response = await GET('/helper/products', {}, {})
		if (httpOk(response)) setProducts(response.data)

		response = await GET('/helper/order-type-subs', {}, {})
		if (httpOk(response)) setOrderTypes(response.data)

		response = await GET('/helper/auto-add-rule-types', {}, {})
		if (httpOk(response)) setAutoAddRuleTypes(response.data)

		store.dispatch(HIDE_LOADER());
	}

	useEffect(() => {
		getDataAll()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('auto_add_products')} [{data?.data?.length}]
				</h4>
				<div className="d-flex">
					<button className="btn-rounded btn btn-primary"
						onClick={() => toggleModal(true)}>
						{t('create')}
					</button>
				</div>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '20%' }}>{t('auto_add_products')}</th>
									<th style={{ 'minWidth': '100px' }}>{t('quantity')}</th>
									<th style={{ 'width': '15%' }}>{t('auto_add_type')}</th>
									<th style={{ 'width': '20%' }}>{t('order_types')}</th>
									<th style={{ 'width': '30%' }}>{t('if_has_dishes')}</th>
									<th style={{ 'minWidth': '110px' }} className="text-center">{t('auto_add_required')}</th>
									<th style={{ 'minWidth': '33px' }}></th>
								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => (
									<tr key={index}>
										<td className="text-center">{index + 1}</td>
										<td className="text-primary cursor"
											onClick={() => toggleModal(true, item)}>
											{item.product_name}
										</td>
										<td>{item.quantity}</td>
										<td>{item.auto_add_rule_type_name}</td>
										<td>{item.order_type_names}</td>
										<td>{item.products_names || '—'}</td>
										<td className="text-center">
											{item.is_required ? (
												<span className="bg-primary bg-border"></span>
											) : (
												<span className="bg-danger bg-border"></span>
											)}
										</td>
										<td>
											<div className="table-dropdown">
												<Dropdown id={`dropdown-${index}`}>
													<Dropdown.Toggle variant="outline-primary">
														<i className="uil uil-ellipsis-v"></i>
													</Dropdown.Toggle>

													<Dropdown.Menu>
														<div className="table-dropdown-item"
															onClick={() => toggleModal(true, item)}>
															<i className="uil-edit-alt"></i>
															{t('edit')}
														</div>
														<div className="table-dropdown-item text-danger"
															onClick={() => {
																setDeleteModalParams({ id: item.id, index: index });
																setModalDelete(true)
															}}>
															<i className="uil-times"></i>
															{t('delete')}
														</div>
													</Dropdown.Menu>
												</Dropdown>
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</div>
			</div>

			{/* MODAL */}
			<Modal show={showModal} animation={false} centered
				dialogClassName="update-modal-width"
				onHide={() => toggleModal()}>
				<Modal.Header closeButton>
					<Modal.Title>
						{!selectedItem.id ?
							<>{t('create')}</>
							:
							<>{t('edit')}</>
						}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={createUpdate} autoComplete="off">
						<div className="form-group">
							<label>{t('product')} *</label>
							<Select
								options={products}
								value={products.find(option => option.id === selectedItem.product_id) || ''}
								onChange={(option) => setSelectedItem({ ...selectedItem, 'product_id': option.id })}
								placeholder=""
								noOptionsMessage={() => t('list_empty')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
						</div>
						<div className="form-group">
							<label>{t('quantity')} *</label>
							<input type="number" className="form-control" name="quantity" min="1" step="1"
								value={selectedItem.quantity ?? ''}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'quantity': e.target.value })} />
						</div>
						<div className="form-group">
							<label>{t('order_type')}</label>
							<Select
								isMulti
								value={selectedItem.order_types}
								options={orderTypes}
								onChange={(options) => setSelectedItem({ ...selectedItem, 'order_types': options || [] })}
								placeholder=""
								noOptionsMessage={() => ""}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
						</div>
						<div className="form-group">
							<label>{t('auto_add_type')} *</label>
							<Select
								options={autoAddRuleTypes}
								value={autoAddRuleTypes.find(option => option.id === selectedItem.auto_add_rule_type_id) || ''}
								onChange={(option) => setSelectedItem({
									...selectedItem,
									auto_add_rule_type_id: option.id,
									auto_add_rule_type_value: option.value,
									products: option.value === AUTO_ADD_TYPE.FOR_DISHES ? (selectedItem.products || []) : [],
								})}
								placeholder=""
								noOptionsMessage={() => t('list_empty')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
						</div>
						{isForDishesType() && (
							<div className="form-group">
								<label>{t('if_has_dishes')} *</label>
								<Select
									isMulti
									options={products}
									value={selectedItem.products || []}
									onChange={(options) => setSelectedItem({
										...selectedItem,
										products: (options || []).map((option) => ({
											id: option.id,
											product_id: option.id,
											name: option.name,
										})),
									})}
									placeholder=""
									noOptionsMessage={() => t('list_empty')}
									getOptionLabel={(option) => option.name}
									getOptionValue={(option) => option.id ?? option.product_id}
								/>
								<div className="form-text">{t('if_has_dishes_help')}</div>
							</div>
						)}
						<div className="form-group">
							<div className="form-check">
								<input type="checkbox" className="form-check-input" id="auto_add_is_required"
									checked={!!selectedItem.is_required}
									onChange={(e) => setSelectedItem({ ...selectedItem, 'is_required': e.target.checked })} />
								<label className="form-check-label" htmlFor="auto_add_is_required">
									{t('auto_add_required')}
								</label>
							</div>
							<div className="form-text">{t('auto_add_required_help')}</div>
						</div>
						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModal()}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">
								{t('save')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL */}

			<DeleteModal
				modalDelete={modalDelete}
				setModalDelete={setModalDelete}
				deleteItem={deleteItem}>
			</DeleteModal>
		</>
	)
}

export default Index
